import { Hyperlink, Typography } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';
import { useTheme } from 'styled-components';

const KycFooter: React.FunctionComponent = () => {
  const theme = useTheme();
  const { formatMessage } = useIntl();

  return (
    <Typography
      display="body2"
      variant="default"
      style={{ color: theme.color.tint.secondary }}
      align="center"
    >
      {formatMessage({ id: 'kyc.footer.contact' })}{' '}
      <Hyperlink href={'mailto:support@hilbi.com?subject=[Onboarding]:'} variant="medium">
        support@hilbi.com
      </Hyperlink>
    </Typography>
  );
};

export default KycFooter;
